document.addEventListener('DOMContentLoaded', () => {
    const returnsForm = document.getElementById("returns-form");
    if (!returnsForm) return;

    let currentStep = 1;
    const totalSteps = 3;
    const formSteps = document.querySelectorAll('.form-step');
    const stepIndicators = document.querySelectorAll('.step-indicator');
    const submitButtons = document.querySelectorAll('#form-submit-btn');
    const backButtons = document.querySelectorAll('#form-back-btn');

    const cityInput = document.getElementById('city');
    const stateSelect = document.getElementById('state');
    const productTypeField = document.getElementById('product-type');
    const productNameField = document.getElementById('product-name');
    const variantNameField = document.getElementById('variant-name');
    const productColorField = document.getElementById('product-color');
    const skuField = document.getElementById('sku');

    const PRODUCT_TYPES_FALLBACK = [
        'Travel Accessories',
        'Briefcases & Duffles',
        'Backpacks',
        'Luggage',
        'Totes & Handbags',
        'Kids Luggage',
        'Kids Backpacks',
        'Rain Umbrellas',
        'Luggage Covers'
    ];

    fetchIndianStates();
    populateProductFields();
    setupStoreDropdown();

    function updateStepDisplay() {
        formSteps.forEach((step, index) => {
            if (index + 1 === currentStep) {
                step.classList.remove('hidden');
            } else {
                step.classList.add('hidden');
            }
        });

        stepIndicators.forEach((indicator, index) => {
            if (index + 1 === currentStep) {
                indicator.classList.add('text-black');
                indicator.classList.remove('text-gray-400');
            } else if (index + 1 < currentStep) {
                indicator.classList.remove('text-gray-400');
                indicator.classList.add('text-black');
            } else {
                indicator.classList.remove('text-black');
                indicator.classList.add('text-gray-400');
            }
        });

        if (submitButtons) {
            if (currentStep === totalSteps) {
                submitButtons.textContent = 'SUBMIT';
                submitButtons.type = 'submit';
            } else {
                submitButtons.textContent = 'SAVE & CONTINUE';
                submitButtons.type = 'button';
            }
        }

        updateBackButtonVisibility();
    }

    function goToNextStep() {
        if (currentStep >= totalSteps) {
            return;
        }
        currentStep++;
        updateStepDisplay();
        return;
    }

    function goToPreviousStep() {
        if (currentStep > 1) {
            currentStep--;
            updateStepDisplay();
        }
    }

    function updateBackButtonVisibility() {
        if (backButtons) {
            if (currentStep === 1) {
                backButtons.classList.add('hidden');
            } else {
                backButtons.classList.remove('hidden');
            }
        }
    }

    function validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    function validatePhone(phone) {
        return /^\d{10}$/.test(phone);
    }

    function validatePincode(pincode) {
        return /^\d{6}$/.test(pincode);
    }

    function showError(fieldId, errorMessage) {
        const errorSpan = document.getElementById(`${fieldId}-error`);
        if (errorSpan) {
            errorSpan.textContent = errorMessage;
        }
    }

    function clearError(fieldId) {
        const errorSpan = document.getElementById(`${fieldId}-error`);
        if (errorSpan) {
            errorSpan.textContent = '';
        }
    }

    function clearAllErrors() {
        const errorFields = [
            'purchase-source', 'full-name', 'email', 'phone', 'address',
            'pincode', 'state', 'city', 'bought-store', 'invoice-id', 'return-reason'
        ];
        errorFields.forEach(fieldId => clearError(fieldId));
    }

    function validateStep1() {
        let isValid = true;
        clearAllErrors();

        const purchaseSource = document.getElementById('purchase-source');
        if (!purchaseSource || !purchaseSource.value || purchaseSource.value === '') {
            showError('purchase-source', 'Please select your source of purchase');
            isValid = false;
        }

        const fullName = document.getElementById('full-name');
        if (!fullName || !fullName.value.trim()) {
            showError('full-name', 'Please enter your full name.');
            isValid = false;
        }

        const phone = document.getElementById('phone');
        if (!phone || !phone.value.trim()) {
            showError('phone', 'Please enter a valid 10-digit phone number.');
            isValid = false;
        } else if (!validatePhone(phone.value.trim())) {
            showError('phone', 'Please enter a valid 10-digit phone number.');
            isValid = false;
        }

        const email = document.getElementById('email');
        if (!email || !email.value.trim()) {
            showError('email', 'Please enter you Email');
            isValid = false;
        }

        const boughtStore = document.getElementById('bought-store');
        if (purchaseSource && purchaseSource.value === 'Mokobara Retail Store') {
            if (!boughtStore || !boughtStore.value || boughtStore.value === '') {
                showError('bought-store', 'Please enter from which store you bought');
                isValid = false;
            }
        }

        const address = document.getElementById('address');
        if (!address || !address.value.trim()) {
            showError('address', 'Please enter your address.');
            isValid = false;
        }

        const city = document.getElementById('city');
        if (!city || !city.value || city.value.trim() === '') {
            showError('city', 'Please enter your city.');
            isValid = false;
        }

        const state = document.getElementById('state');
        if (!state || !state.value || state.value === '') {
            showError('state', 'Please enter your State.');
            isValid = false;
        }

        const pincode = document.getElementById('pincode');
        if (!pincode || !pincode.value.trim()) {
            showError('pincode', 'Please enter your pincode.');
            isValid = false;
        } else if (!validatePincode(pincode.value.trim())) {
            showError('pincode', 'Please enter your pincode.');
            isValid = false;
        }

        if (!isValid) {
            const firstError = document.querySelector('.error-message:not(:empty)');
            if (firstError) {
                const fieldset = firstError.previousElementSibling;
                if (fieldset) {
                    fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }
        }

        return isValid;
    }

    function validateStep2() {
        let isValid = true;

        if (!productTypeField || !productTypeField.value || productTypeField.value === '') {
            showError('product-type', 'Please select your Product Type.');
            isValid = false;
        }

        if (!productNameField || !productNameField.value || productNameField.value === '') {
            showError('product-name', 'Please select your Product Name.');
            isValid = false;
        }

        if (!variantNameField || !variantNameField.value || variantNameField.value === '') {
            showError('variant-name', 'Please select your Variant.');
            isValid = false;
        }

        const purchaseDateInput = document.getElementById('purchase-date');
        if (!purchaseDateInput || !purchaseDateInput.value || purchaseDateInput.value.trim() === '') {
            showError('purchase-date', 'Please enter your purchase Date.');
            isValid = false;
        } else {
            const selectedDate = new Date(purchaseDateInput.value);
            const today = new Date();
            today.setHours(23, 59, 59, 999);

            if (selectedDate > today) {
                showError('purchase-date', 'Purchase date cannot be in the future');
                isValid = false;
            }
        }

        const invoiceInput = document.getElementById('invoice');
        if (!invoiceInput || !invoiceInput.files || invoiceInput.files.length === 0) {
            showError('invoice', 'Please upload your invoice.');
            isValid = false;
        } else {
            const file = invoiceInput.files[0];
            const allowedInvoiceExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];
            const allowedInvoiceTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
            const fileName = (file.name || '').toLowerCase();
            const ext = fileName.includes('.') ? '.' + fileName.split('.').pop() : '';
            const typeAllowed = allowedInvoiceTypes.includes(file.type);
            const extAllowed = allowedInvoiceExtensions.includes(ext);

            if (!typeAllowed && !extAllowed) {
                showError('invoice', 'Only PDF, JPG, JPEG and PNG files are allowed');
                isValid = false;
            } else if (file.size > 20 * 1024 * 1024) {
                showError('invoice', 'Invoice file size must not exceed 20MB');
                isValid = false;
            }
        }

        const prodImagesInput = document.getElementById('prod-images');
        const prodImageCount = prodImagesInput && prodImagesInput.files ? prodImagesInput.files.length : 0;
        if (prodImageCount < 1 || prodImageCount > 2) {
            showError('prod-images', 'Please select at least one image.');
            isValid = false;
        }

        if (!isValid) {
            const firstError = document.querySelector('.error-message:not(:empty)');
            if (firstError) {
                const fieldContainer = firstError.closest('.form-field');
                if (fieldContainer) {
                    fieldContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }
        }

        return isValid;
    }

    function validateStep3() {
        let isValid = true;

        const accountName = document.getElementById('account-name');
        if (!accountName || !accountName.value.trim()) {
            showError('account-name', 'Please select your Account Name');
            isValid = false;
        }

        const accountNumber = document.getElementById('account-number');
        if (!accountNumber || !/^\d{6,34}$/.test(accountNumber.value.trim())) {
            showError('account-number', 'Please Enter Valid Account Number');
            isValid = false;
        }

        const ifscCode = document.getElementById('ifsc-code');
        if (!ifscCode || !/^[A-Za-z]{4}0[A-Za-z0-9]{6}$/.test(ifscCode.value.trim())) {
            showError('ifsc-code', 'Please Enter Valid IfSC Code');
            isValid = false;
        }

        if (!isValid) {
            const firstError = document.querySelector('.error-message:not(:empty)');
            if (firstError) {
                const fieldContainer = firstError.closest('.form-field');
                if (fieldContainer) {
                    fieldContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }
        }

        return isValid;
    }

    const emailInput = document.getElementById('email');
    if (emailInput) {
        emailInput.addEventListener('input', function () {
            clearError('email');
        });
    }

    const phoneInput = document.getElementById('phone');
    if (phoneInput) {
        phoneInput.addEventListener('input', () => {
            clearError('phone');
        });
    }

    const pincodeInput = document.getElementById('pincode');
    if (pincodeInput) {
        pincodeInput.addEventListener('input', function (event) {
            let pincode = event.target.value.replace(/\D/g, '');

            if (pincode.length > 6) {
                pincode = pincode.slice(0, 6);
            }

            event.target.value = pincode;
            clearError('pincode');

            if (pincode.length === 6) {
                getCityState(pincode);
            } else {
                if (cityInput) cityInput.value = '';
                if (stateSelect) {
                    stateSelect.innerHTML = '<option value="" disabled selected>Select a State</option>';
                    fetchIndianStates();
                }
            }
        });
    }

    const platformLinks = {
        "Amazon": "https://www.amazon.in/",
        "Flipkart": "https://www.flipkart.com/",
        "Myntra": "https://www.myntra.com/",
        "Ajio": "https://www.ajio.com/",
        "TataCliq": "https://www.tatacliq.com/",
        "FirstCry": "https://www.firstcry.com/"
    };

    const purchaseSource = document.getElementById('purchase-source');
    const orderHistoryButton = document.getElementById('order-history-button');
    const step1FormFields = document.getElementById('step1-form-fields');
    const step1ButtonContainer = document.querySelector('.form-step.step-1 .mt-8.flex');
    const externalPlatformMessage = document.getElementById('external-platform-message');
    const platformLink = document.getElementById('platform-link');
    const storeFieldWrapper = document.getElementById('store-field-wrapper');

    const getOtherFormFields = function () {
        if (!step1FormFields) return [];
        const allFields = step1FormFields.querySelectorAll('.form-field');
        return Array.from(allFields).filter(field => field.id !== 'store-field-wrapper').slice(1);
    };

    if (purchaseSource) {
        purchaseSource.addEventListener('change', function () {
            clearError('purchase-source');

            const otherFields = getOtherFormFields();
            const selectedValue = this.value;

            if (storeFieldWrapper) {
                if (selectedValue === 'Mokobara Retail Store') {
                    storeFieldWrapper.classList.remove('hidden');
                } else {
                    storeFieldWrapper.classList.add('hidden');
                }
            }

            if (selectedValue === 'Mokobara Website') {
                if (orderHistoryButton) {
                    orderHistoryButton.classList.remove('hidden');
                }
                if (externalPlatformMessage) {
                    externalPlatformMessage.classList.add('hidden');
                }
                otherFields.forEach(field => {
                    field.classList.add('hidden');
                });
                if (step1ButtonContainer) {
                    step1ButtonContainer.classList.add('hidden');
                }
                return;
            }
            if (selectedValue === 'Mokobara Retail Store') {
                if (orderHistoryButton) {
                    orderHistoryButton.classList.add('hidden');
                }
                if (externalPlatformMessage) {
                    externalPlatformMessage.classList.add('hidden');
                }
                otherFields.forEach(field => {
                    field.classList.remove('hidden');
                });
                if (step1ButtonContainer) {
                    step1ButtonContainer.classList.remove('hidden');
                }
                return;
            }
            if (platformLinks[selectedValue]) {
                if (orderHistoryButton) {
                    orderHistoryButton.classList.add('hidden');
                }
                if (externalPlatformMessage && platformLink) {
                    platformLink.textContent = selectedValue;
                    platformLink.href = platformLinks[selectedValue];
                    externalPlatformMessage.classList.remove('hidden');
                }
                otherFields.forEach(field => {
                    field.classList.remove('hidden');
                });
                if (step1ButtonContainer) {
                    step1ButtonContainer.classList.remove('hidden');
                }
                return;
            }
            if (orderHistoryButton) {
                orderHistoryButton.classList.add('hidden');
            }
            if (externalPlatformMessage) {
                externalPlatformMessage.classList.add('hidden');
            }
            otherFields.forEach(field => {
                field.classList.remove('hidden');
            });
            if (step1ButtonContainer) {
                step1ButtonContainer.classList.remove('hidden');
            }
        });
    }

    const fullNameInput = document.getElementById('full-name');
    if (fullNameInput) {
        fullNameInput.addEventListener('input', () => {
            clearError('full-name');
        });
    }

    const addressInput = document.getElementById('address');
    if (addressInput) {
        addressInput.addEventListener('input', () => {
            clearError('address');
        });
    }

    if (stateSelect) {
        stateSelect.addEventListener('change', () => {
            clearError('state');
        });
    }

    if (cityInput) {
        cityInput.addEventListener('input', () => {
            clearError('city');
        });
    }

    const boughtStoreSelect = document.getElementById('bought-store');
    if (boughtStoreSelect) {
        boughtStoreSelect.addEventListener('change', () => {
            clearError('bought-store');
        });
    }

    const invoiceIdInput = document.getElementById('invoice-id');
    if (invoiceIdInput) {
        invoiceIdInput.addEventListener('input', () => {
            clearError('invoice-id');
        });
    }

    const invoiceInput = document.getElementById('invoice');
    if (invoiceInput) {
        const allowedInvoiceExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];
        const allowedInvoiceTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];

        invoiceInput.addEventListener('change', function () {
            const file = this.files && this.files[0];
            if (!file) {
                clearError('invoice');
                return;
            }
            const fileName = (file.name || '').toLowerCase();
            const ext = fileName.includes('.') ? '.' + fileName.split('.').pop() : '';
            const typeAllowed = allowedInvoiceTypes.includes(file.type);
            const extAllowed = allowedInvoiceExtensions.includes(ext);

            if (!typeAllowed && !extAllowed) {
                showError('invoice', 'Only PDF, JPG, JPEG and PNG files are allowed');
                this.value = '';
                return;
            }
            if (file.size > 20 * 1024 * 1024) {
                showError('invoice', 'Invoice file size must not exceed 20MB');
                this.value = '';
                return;
            }
            clearError('invoice');
        });
    }

    const returnReasonSelect = document.getElementById('return-reason');
    if (returnReasonSelect) {
        returnReasonSelect.addEventListener('change', () => {
            clearError('return-reason');
        });
    }

    const accountNameInput = document.getElementById('account-name');
    if (accountNameInput) {
        accountNameInput.addEventListener('input', () => {
            clearError('account-name');
        });
    }

    const accountNumberInput = document.getElementById('account-number');
    if (accountNumberInput) {
        accountNumberInput.addEventListener('input', () => {
            clearError('account-number');
        });
    }

    const ifscCodeInput = document.getElementById('ifsc-code');
    if (ifscCodeInput) {
        ifscCodeInput.addEventListener('input', () => {
            clearError('ifsc-code');
        });
    }

    if (submitButtons.length > 0) {
        submitButtons.forEach((button) => {
            button.addEventListener('click', (e) => {

                if (currentStep >= totalSteps) {
                    return;
                }
                e.preventDefault();

                if (currentStep === 1) {
                    if (!validateStep1()) {
                        return;
                    }
                } else if (currentStep === 2 && !validateStep2()) {
                    return;
                }
                goToNextStep();
                return;
            });
        });
    } else {
        console.error('Submit button not found!');
    }

    if (backButtons.length > 0) {
        backButtons.forEach((button) => {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                goToPreviousStep();
            });
        });
    }

    function showLoader() {
        const submitBtn = document.getElementById('form-submit-btn');
        const submitBtnText = document.getElementById('submit-btn-text');
        const submitBtnSpinner = document.getElementById('submit-btn-spinner');

        if (!(submitBtn && submitBtnText && submitBtnSpinner)) {
            return;
        }
        submitBtnText.classList.add('hidden');
        submitBtnSpinner.classList.remove('hidden');
        submitBtn.disabled = true;
    }

    function hideLoader() {
        const submitBtn = document.getElementById('form-submit-btn');
        const submitBtnText = document.getElementById('submit-btn-text');
        const submitBtnSpinner = document.getElementById('submit-btn-spinner');

        if (!(submitBtn && submitBtnText && submitBtnSpinner)) {
            return;
        }
        submitBtnText.classList.remove('hidden');
        submitBtnSpinner.classList.add('hidden');
        submitBtn.disabled = false;
    }

    function disableFormFields() {
        const allInputs = returnsForm.querySelectorAll('input, select, textarea, button');
        allInputs.forEach(field => {
            field.disabled = true;
            field.classList.add('pointer-events-none', 'opacity-60');
        });
    }

    function enableFormFields() {
        const allInputs = returnsForm.querySelectorAll('input, select, textarea, button');
        allInputs.forEach(field => {
            field.disabled = false;
            field.classList.remove('pointer-events-none', 'opacity-60');
        });
    }

    returnsForm.addEventListener("submit", async function (e) {
        e.preventDefault();

        if (currentStep === 3 && !validateStep3()) {
            return;
        }

        const returnsApi = 'https://themokolabs.com/api/customer/create-thirty-day-trial-form-online';

        showLoader();
        disableFormFields();

        try {
            const result = await handleReturnSubmission(returnsApi);
            enableFormFields();

            const overlay = document.getElementById('form-overlay');
            const successIcon = overlay?.querySelector('#success-icon');
            const errorIcon = overlay?.querySelector('#error-icon');
            const messageText = overlay?.querySelector('#overlay-message');

            if (overlay && successIcon && messageText) {
                errorIcon?.classList.add('hidden');
                successIcon.classList.remove('hidden');
                messageText.textContent = result?.message || 'Form submitted successfully!';
                overlay.classList.remove('hidden');
                overlay.classList.add('flex');
            }
        } catch (error) {
            console.error('Error:', error);

            const overlay = document.getElementById('form-overlay');
            const successIcon = overlay?.querySelector('#success-icon');
            const errorIcon = overlay?.querySelector('#error-icon');
            const messageText = overlay?.querySelector('#overlay-message');

            if (overlay && errorIcon && messageText) {
                successIcon?.classList.add('hidden');
                errorIcon.classList.remove('hidden');

                let errorMsg = 'Error submitting form. Please try again.';
                if (error.message) {
                    errorMsg = error.message;
                } else if (typeof error === 'string') {
                    errorMsg = error;
                }

                messageText.textContent = errorMsg;
                overlay.classList.remove('hidden');
                overlay.classList.add('flex');
            }

            enableFormFields();
        } finally {
            hideLoader();
        }
    });

    async function fetchIndianStates() {
        const url = "https://countriesnow.space/api/v0.1/countries/states";
        if (!stateSelect) return;

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ country: "India" })
            });

            const data = await response.json();
            if (data.error === false) {
                const states = data.data.states;
                states.forEach(state => {
                    const option = document.createElement("option");
                    option.value = state.name;
                    option.textContent = state.name;
                    stateSelect.appendChild(option);
                });
            } else {
                console.error("Error fetching states:", data.msg);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    }

    function getCityState(pincode) {
        if (pincode.length === 6) {
            fetch(`https://api.postalpincode.in/pincode/${pincode}`)
                .then(response => response.json())
                .then(data => {
                    if (data[0].Status === "Success") {
                        const city = data[0].PostOffice[0].District;
                        const state = data[0].PostOffice[0].State;

                        if (cityInput) {
                            cityInput.value = city;
                            clearError('city');
                        }

                        if (stateSelect) {
                            stateSelect.innerHTML = '';
                            const stateOption = new Option(state, state);
                            stateSelect.appendChild(stateOption);
                            stateSelect.value = state;
                            clearError('state');
                        }
                        return;
                    }
                    alert("Invalid Pincode");
                })
                .catch(error => console.error('Error:', error));
        }
    }


    function renderProductTypes(types) {
        if (!productTypeField) return;
        productTypeField.innerHTML = '<option value="" disabled selected>Select a product type</option>';
        types.forEach(type => {
            const option = document.createElement('option');
            option.value = type;
            option.textContent = type || 'Unknown Product Type';
            productTypeField.appendChild(option);
        });
    }

    async function populateProductFields() {
        if (!productTypeField) return;
        productTypeField.innerHTML = '<option value="" disabled selected>Loading product types...</option>';

        try {
            const response = await fetch('https://themokolabs.com/api/customer/30day/get-product-types');
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const data = await response.json();
            const types = Array.isArray(data?.product_types) && data.product_types.length > 0
                ? data.product_types
                : PRODUCT_TYPES_FALLBACK;
            renderProductTypes(types);
        } catch (error) {
            console.error('Error fetching product types:', error);
            renderProductTypes(PRODUCT_TYPES_FALLBACK);
        }
    }

    async function setupStoreDropdown() {
        const purchaseSource = document.getElementById('purchase-source');
        const boughtStore = document.getElementById('bought-store');

        if (!purchaseSource || !boughtStore) return;

        purchaseSource.addEventListener('change', function () {
            const selectedValue = this.value;
            boughtStore.innerHTML = '<option value="" disabled selected>Select a store</option>';

            if (selectedValue === 'Mokobara Retail Store') {
                boughtStore.disabled = false;
                fetchStoreCodes();
            } else {
                boughtStore.disabled = true;
            }
        });
    }

    async function fetchStoreCodes() {
        const boughtStore = document.getElementById('bought-store');
        if (!boughtStore) return;

        const fallbackMessage = 'Stores temporarily unavailable. Please try again.';
        try {
            const response = await fetch('https://themokolabs.com/api/customer/get-store-codes-and-names');

            if (!response.ok) {
                console.error('Store codes API error:', response.status, response.statusText);
                boughtStore.innerHTML = '<option value="" disabled selected>' + fallbackMessage + '</option>';
                return;
            }

            const data = await response.json();

            if (data.stores && data.stores.length > 0) {
                data.stores.forEach(store => {
                    const option = document.createElement('option');
                    option.value = store.store_code;
                    option.textContent = store.store_name;
                    boughtStore.appendChild(option);
                });
            } else {
                boughtStore.innerHTML = '<option value="" disabled selected>' + fallbackMessage + '</option>';
            }
        } catch (error) {
            console.error('Error fetching store codes:', error);
            boughtStore.innerHTML = '<option value="" disabled selected>' + fallbackMessage + '</option>';
        }
    }

    if (productTypeField) {
        productTypeField.addEventListener('change', function (event) {
            if (skuField) skuField.value = '';
            if (productColorField) productColorField.value = '';
            if (variantNameField) {
                variantNameField.innerHTML = '<option value="" disabled selected>Select a Variant Name</option>';
                variantNameField.disabled = true;
                variantNameField.setAttribute('aria-disabled', 'true');
            }

            const selectedType = event.target.value;
            if (!productNameField) return;

            productNameField.innerHTML = '<option value="" disabled selected>Select a product</option>';

            if (!selectedType) {
                productNameField.disabled = true;
                productNameField.setAttribute('aria-disabled', 'true');
                if (variantNameField) {
                    variantNameField.disabled = true;
                    variantNameField.setAttribute('aria-disabled', 'true');
                    variantNameField.innerHTML = '<option value="" disabled selected>Select a Variant Name</option>';
                }
                return;
            }

            productNameField.disabled = false;
            productNameField.setAttribute('aria-disabled', 'false');
            productNameField.innerHTML = '<option value="" disabled selected>Loading products...</option>';

            const prodType = encodeURIComponent(selectedType);
            const productFallbackMessage = 'Products temporarily unavailable. Please try again.';
            fetch(`https://themokolabs.com/api/customer/30day/get-product-names?type=${prodType}`)
                .then((response) => {
                    if (!response.ok) {
                        console.error('Product names API error:', response.status, response.statusText);
                        productNameField.innerHTML = '<option value="" disabled selected>' + productFallbackMessage + '</option>';
                        return null;
                    }
                    return response.json();
                })
                .then((data) => {
                    if (data === null) return;
                    if (data.product_names && data.product_names.length > 0) {
                        productNameField.innerHTML = '<option value="" disabled selected>Select a product</option>';

                        data.product_names.forEach((productName) => {
                            const option = document.createElement('option');
                            option.value = productName;
                            option.textContent = productName;
                            productNameField.appendChild(option);
                        });
                    } else {
                        productNameField.innerHTML = '<option value="" disabled selected>No products available for this type</option>';
                    }
                })
                .catch((error) => {
                    console.error("Error fetching product names:", error);
                    productNameField.innerHTML = '<option value="" disabled selected>' + productFallbackMessage + '</option>';
                });
        });
    }

    if (productNameField) {
        productNameField.addEventListener('change', function () {
            if (this.value && this.value !== '') {
                updateVariantDetails();
            } else {
                if (variantNameField) {
                    variantNameField.disabled = true;
                    variantNameField.setAttribute('aria-disabled', 'true');
                    variantNameField.innerHTML = '<option value="" disabled selected>Select a Variant Name</option>';
                    if (skuField) skuField.value = '';
                    if (productColorField) productColorField.value = '';
                }
            }
        });
    }

    function updateVariantDetails() {
        if (!productNameField || !variantNameField || !productTypeField) return;

        const selectedType = productTypeField.value;
        const selectedName = productNameField.value;

        if (!selectedType || !selectedName) {
            variantNameField.disabled = true;
            variantNameField.setAttribute('aria-disabled', 'true');
            variantNameField.innerHTML = '<option value="" disabled selected>Select a Variant Name</option>';
            if (skuField) skuField.value = '';
            if (productColorField) productColorField.value = '';
            return;
        }

        variantNameField.disabled = false;
        variantNameField.setAttribute('aria-disabled', 'false');
        variantNameField.innerHTML = '<option value="" disabled selected>Loading variants...</option>';

        const encodedType = encodeURIComponent(selectedType);
        const encodedName = encodeURIComponent(selectedName);

        fetch(`https://themokolabs.com/api/customer/30day/get-product-variants?type=${encodedType}&name=${encodedName}`)
            .then(response => response.json())
            .then(data => {
                variantNameField.innerHTML = '<option value="" disabled selected>Select a Variant Name</option>';

                if (data.variants && Array.isArray(data.variants) && data.variants.length > 0) {
                    data.variants.forEach(variant => {
                        const option = document.createElement('option');
                        option.value = variant;
                        option.textContent = variant;
                        variantNameField.appendChild(option);
                    });

                    if (data.variants.length === 1) {
                        variantNameField.value = data.variants[0];
                        variantNameField.dispatchEvent(new Event('change'));
                    }
                } else {
                    console.error('Error in variant API response:', data.message || 'No variants found');
                    variantNameField.innerHTML = '<option value="" disabled selected>No variants available</option>';
                }
            })
            .catch(error => {
                console.error('Error fetching variant data:', error);
                variantNameField.innerHTML = '<option value="" disabled selected>Error loading variants</option>';
            });
    }

    if (variantNameField) {
        variantNameField.addEventListener('change', function () {
            const selectedType = productTypeField.value;
            const selectedName = productNameField.value;
            const selectedVariant = variantNameField.value;

            if (!selectedType || !selectedName || !selectedVariant) {
                if (skuField) skuField.value = '';
                if (productColorField) productColorField.value = '';
                return;
            }

            const encodedType = encodeURIComponent(selectedType);
            const encodedName = encodeURIComponent(selectedName);
            const encodedVariant = encodeURIComponent(selectedVariant);

            fetch(`https://themokolabs.com/api/customer/30day/get-product-sku?type=${encodedType}&name=${encodedName}&variant=${encodedVariant}`)
                .then(response => response.json())
                .then(data => {
                    if (data.sku || data.color) {
                        if (skuField) skuField.value = data.sku || '';
                        if (productColorField) productColorField.value = data.color || '';
                    }
                })
                .catch(error => {
                    console.error('Error fetching SKU and color:', error);
                });
        });
    }

    const purchaseDateInput = document.getElementById('purchase-date');
    if (purchaseDateInput) {
        const today = new Date().toISOString().split('T')[0];
        purchaseDateInput.setAttribute('max', today);

        const dateContainer = purchaseDateInput.closest('.form-field');
        if (dateContainer) {
            dateContainer.addEventListener('click', function (e) {
                if (e.target === purchaseDateInput || e.target.closest('fieldset') === purchaseDateInput.closest('fieldset')) {
                    purchaseDateInput.showPicker?.();
                }
            });
        }

        purchaseDateInput.addEventListener('change', function () {
            const selectedDate = new Date(this.value);
            const todayDate = new Date();
            todayDate.setHours(23, 59, 59, 999);

            if (this.value && selectedDate > todayDate) {
                showError('purchase-date', 'Purchase date cannot be in the future');
                this.value = '';
                return;
            }

            // Eligibility window: 30 days for Mokobara Retail Store, 45 for everything else
            if (this.value) {
                const purchaseSourceVal = document.getElementById('purchase-source')?.value || '';
                const dayReturn = purchaseSourceVal === 'Mokobara Retail Store' ? 30 : 45;
                const oldestEligibleDate = new Date();
                oldestEligibleDate.setDate(oldestEligibleDate.getDate() - dayReturn);
                oldestEligibleDate.setHours(0, 0, 0, 0);

                if (selectedDate < oldestEligibleDate) {
                    showExpiredTrialOverlay();
                    this.value = '';
                    return;
                }
            }

            clearError('purchase-date');
        });

        purchaseDateInput.addEventListener('input', () => {
            clearError('purchase-date');
        });
    }

    function showExpiredTrialOverlay() {
        const overlay = document.getElementById('form-overlay');
        if (!overlay) return;
        const successIcon = overlay.querySelector('#success-icon');
        const errorIcon = overlay.querySelector('#error-icon');
        const messageText = overlay.querySelector('#overlay-message');

        if (successIcon) successIcon.classList.add('hidden');
        if (errorIcon) errorIcon.classList.remove('hidden');
        if (messageText) {
            messageText.innerHTML = "Your free trial has expired. <a href='/pages/claim-my-warranty' style='text-decoration: underline; text-underline-offset: 3px;'>Click here</a> to claim your warranty.";
        }
        overlay.classList.remove('hidden');
        overlay.classList.add('flex');
    }

    const prodImagesInput = document.getElementById('prod-images');
    if (prodImagesInput) {
        prodImagesInput.addEventListener('change', async function (event) {
            const fileInput = event.target;
            const files = Array.from(fileInput.files);
            const dataTransfer = new DataTransfer();
            let validFileCount = 0;
            const rejectedFiles = [];

            for (const file of files) {
                if (validFileCount >= 2) {
                    rejectedFiles.push(`${file.name} - Only the first 2 files are allowed`);
                    continue;
                }
                if (!/\.(jpg|jpeg|png)$/i.test(file.name)) {
                    rejectedFiles.push(`${file.name} - Only JPG, JPEG, and PNG images are allowed`);
                    continue;
                }
                if (file.size > 10 * 1024 * 1024) {
                    rejectedFiles.push(`${file.name} - File exceeds 10MB limit`);
                    continue;
                }

                dataTransfer.items.add(file);
                validFileCount++;
            }

            fileInput.files = dataTransfer.files;
            clearError('prod-images');

            if (rejectedFiles.length > 0) {
                alert(`The following files were not uploaded:\n${rejectedFiles.join("\n")}`);
            }
        });
    }

    async function handleReturnSubmission(url) {
        const platformName = document.getElementById("purchase-source").value;
        const fullName = document.getElementById("full-name").value;
        const phone = document.getElementById("phone").value;
        const email = document.getElementById("email").value;
        const boughtFromStore = document.getElementById("bought-store")?.value || '';
        const address = document.getElementById("address").value;
        const city = document.getElementById("city").value;
        const state = document.getElementById("state").value;
        const pincode = document.getElementById("pincode").value;
        const sku = document.getElementById("sku").value;
        const purchaseDate = document.getElementById("purchase-date").value;
        const invoiceId = document.getElementById("invoice-id").value;
        const invoice = document.getElementById("invoice").files[0];
        const prodImages = document.getElementById("prod-images").files;
        const returnReason = document.getElementById("return-reason").value;
        const accountName = document.getElementById("account-name").value;
        const accountNumber = document.getElementById("account-number").value;
        const ifscCode = document.getElementById("ifsc-code").value;
        const remarks = document.getElementById("remarks")?.value.trim() || '';

        function formatDateForAPI(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        }

        const formData = new FormData();
        formData.append("purchased_from_platform", platformName);
        formData.append("customer_name", fullName);
        formData.append("customer_email", email);
        formData.append("customer_phone", phone);
        if (platformName === 'Mokobara Retail Store' && boughtFromStore) {
            formData.append("purchased_from_store_code", boughtFromStore);
        }
        formData.append("address", address);
        formData.append("city", city);
        formData.append("state", state);
        formData.append("pincode", pincode);
        formData.append("product_sku", sku);
        formData.append("purchased_date", formatDateForAPI(purchaseDate));
        formData.append("invoice_id", invoiceId);
        formData.append("return_reason", returnReason);

        if (invoice) {
            formData.append("invoice_files", invoice);
        }

        Array.from(prodImages).forEach((file) => {
            formData.append("uploaded_product_image_urls", file);
        });

        formData.append("bank_holder_name", accountName);
        formData.append("account_number", accountNumber);
        formData.append("ifsc_code", ifscCode);

        if (remarks) {
            formData.append("remarks", remarks);
        }

        const response = await fetch(url, {
            method: "POST",
            body: formData
        });

        const responseData = await response.json();

        if (!response.ok) {
            const errorMessage = responseData?.error || responseData?.message || `HTTP error! status: ${response.status}`;
            throw new Error(errorMessage);
        }

        return responseData;
    }

    function closeOverlay() {
        const overlay = document.getElementById('form-overlay');
        const successIcon = overlay?.querySelector('#success-icon');

        if (overlay) {
            overlay.classList.add('hidden');
            overlay.classList.remove('flex');
        }

        enableFormFields();

        if (!(successIcon && !successIcon.classList.contains('hidden'))) {
            return;
        }
        returnsForm.reset();
        const stateDropdown = document.getElementById("state");
        if (stateDropdown) {
            stateDropdown.innerHTML = '<option value="" selected>Select State</option>';
            fetchIndianStates();
        }
        const productNameDropdown = document.getElementById("product-name");
        if (productNameDropdown) {
            productNameDropdown.innerHTML = '<option value="" selected>Select a Product</option>';
        }
        currentStep = 1;
        updateStepDisplay();
    }

    const overlayCloseBtn = document.getElementById('overlay-close-btn');
    if (overlayCloseBtn) {
        overlayCloseBtn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            closeOverlay();
        });
    }

    const overlay = document.getElementById('form-overlay');
    const overlayContent = document.getElementById('overlay-content');
    if (overlay) {
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) {
                closeOverlay();
            }
        });
    }

    if (overlayContent) {
        overlayContent.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    }

    updateStepDisplay();
});
